export default {
    namespaced: true,
    state: {
        currentRoute: {
            path: '/',
            name: 'Home'
        }
    },
    getters: {
        currentPath: state => state.currentRoute.path,
        currentName: state => state.currentRoute.name
    },
    mutations: {
        SET_CURRENT_ROUTE(state, route) {
            state.currentRoute = {
                path: route.path,
                name: route.name
            }
        }
    },
    actions: {
        updateRoute({ commit }, route) {
            commit('SET_CURRENT_ROUTE', route)
        }
    }
}
